import Vue from 'vue'
import App from './App.vue'
import router from './router.js'
import VueWechatTitle from 'vue-wechat-title'
Vue.use(VueWechatTitle);

Vue.config.productionTip = false


new Vue({

  //一定要注入到vue的实例对象上
  router,
  render: h => h(App),
}).$mount('#app')
const defaultTitle = '演示DEMO-重庆乾端科技有限公司'
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  //to 都是数组对象   
  if (to.meta.title) {
    window.document.title = to.meta.title ? to.meta.title : defaultTitle
  }
 
 

  next()

})
